import {
    RESET_SESSION_DATA,
    SET_AGENDA_SESSION,
    SET_AGENDA_SESSION_ERROR,
    SET_AGENDA_SESSION_SPEAKERS,
    SET_AGENDA_SESSION_RATE,
    SET_SESSION_FULL_REGISTRATION,
    SET_SESSION_OVERLAPPING_REGISTRATION,
    SET_VIRTUAL_SESSION_DETAILS,
    SET_CURRENT_RECORD_URL,
    SET_SESSION_UPCOMING_SESSIONS
} from '../constants/ActionTypes';

const initialState = {
    serverRendered: false,
    session: null,
    speakers: null,
    recordUrl: null,

    virtualDetails: null,
    error: null,
};

const updateItemInObject = (item, itemId, updateItemCallback) => {
    const curItemId = item && item.id;
    return curItemId === itemId ? updateItemCallback(item) : item;
};

const SessionReducer = (state = initialState, action = null) => {
    switch (action.type) {
    case RESET_SESSION_DATA:
        return {
            ...initialState,
            virtualDetails: state.virtualDetails,
        };
    case SET_AGENDA_SESSION:
        return {
            ...state,
            error: null,
            session: action.payload,
        };
    case SET_AGENDA_SESSION_ERROR: {
        return {
            ...state,
            error: action.payload,
        };
    }
    case SET_AGENDA_SESSION_SPEAKERS:
        return {
            ...state,
            speakers: action.payload
        };
    case SET_AGENDA_SESSION_RATE:
        return {
            ...state,
            rate: action.payload.rate,
            feedback: action.payload.feedback
        };
    case SET_SESSION_FULL_REGISTRATION: {
        const newSession = updateItemInObject(state.session, action.sessionId, (session) => ({
            ...session,
            registrationFull: action.isFullRegistration
        }));
        return {
            ...state,
            session: newSession
        };
    }
    case SET_SESSION_OVERLAPPING_REGISTRATION: {
        const newSession = updateItemInObject(state?.session || [], action.sessionId, (session) => ({
            ...session, ...{
                overlapping: action.isOverlapping
            }
        }));
        return {
            ...state,
            session: newSession
        };
    }
    case SET_VIRTUAL_SESSION_DETAILS: {
        const { sessionId, virtualDetails } = action.payload;
        if (virtualDetails) {
            return {
                ...state,
                virtualDetails: {
                    sessionId,
                    ...virtualDetails
                }
            };
        }

        return { ...state, virtualDetails: null };
    }
    case SET_CURRENT_RECORD_URL: {
        const { url } = action.payload;
        return {
            ...state,
            recordUrl: url
        };
    }

    case SET_SESSION_UPCOMING_SESSIONS: {
        const { sessions } = action.payload;
        return {
            ...state,
            upcomingSessions: sessions
        };
    }

    default:
        return state;
    }
};

export default SessionReducer;
